<template>
  <table class="table table-hover table-center mb-0 datatable">
    <thead style="background-color: ghostwhite">
    <tr class="text-center">
      <th v-for="(column, index) in columns" :key="index" :class="column.thClass || 'text-left'"
          v-show="!column.hidden">
        {{ column.label }}
      </th>
      <th v-if="hasActionSlot" class="text-right">Action</th>
    </tr>
    </thead>
    <LoadingSkeleton v-if="isLoading" :rows="10" :columns="skeletonColumnCount"/>
    <tbody v-else>
    <tr v-if="items.length" class="text-center clickable-row" v-for="(item, index) in items" :key="item.id || index" @click="handleRowClick(item)">
      <td v-for="(column, colIndex) in columns"
          :key="colIndex"
          :col="`${column.label}: `"
          :class="column.tdClass || 'text-left'"
          v-show="!column.hidden">
        <slot :name="column.key" :item="item">
          {{ formatCell(item, column) }}
        </slot>
      </td>
      <td class="text-right" v-if="hasActionSlot">
        <slot name="actions" :item="item"></slot>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import LoadingSkeleton from "../shared/LoadingSkeleton.vue";

export default {
  name: 'PageTable',
  components: {LoadingSkeleton},
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    hasActionSlot() {
      return !!this.$scopedSlots.actions;
    },
    skeletonColumnCount() {
      const visibleColumns = this.columns.filter(c => !c.hidden).length;
      return this.hasActionSlot ? visibleColumns + 1 : visibleColumns;
    }
  },
  methods: {
    getValue(item, key) {
      try {
        return key.split('.').reduce(function (acc, k) {
          return acc && acc[k] !== undefined ? acc[k] : undefined;
        }, item) || '-';
      } catch (e) {
        return '-';
      }
    },
    formatCell(item, column) {
      const value = this.getValue(item, column.key);
      return typeof column.formatter === 'function'
        ? column.formatter(value, item)
        : value;
    },
    handleRowClick(item) {
      this.$emit('row-click', item);
    }
  }
}
</script>


<style scoped>
.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/PageTable.vue